import endpoints from 'endpoints';
import urljoin from 'url-join';
import { getPlaceholderPhoto } from 'utils/get-placeholder-photo';

export const getImageUrl = (image?: string) =>
  image ? urljoin(process.env.REACT_APP_EV_URL, endpoints.PERKS_IMAGE, image) : getPlaceholderPhoto();
